module.exports = __webpack_public_path__ + "img/youpaq-logo-white.746f3861.svg";